import React from "react";
// Removed unused import
import ConsentStatusViewer from "../components/ConsentStatusViewer";
import mekoLogo from "../assets/MEKO_LOGO.svg";

const DatenschutzDe = () => {
  return (
    <div className="container" style={{ paddingTop: 50, paddingBottom: 50 }}>
      <div style={{ marginBottom: 30 }}>
        <a href="/">
          <img src={mekoLogo} alt="MEKO Logo" className="hero-logo-badge" />
        </a>
      </div>
      <h1>Datenschutzerklärung</h1>

      <p>
        Wir freuen uns über Ihren Besuch auf unserer Internetseite und Ihr
        Interesse an unserem Unternehmen. Eine Nutzung unserer Internetseite ist
        grundsätzlich ohne Angabe personenbezogener Daten möglich. Datenschutz
        hat einen hohen Stellenwert für uns, deshalb informieren wir Sie stets
        transparent in unserer unten angefügten Datenschutzerklärung, wie wir
        mit ihren Daten umgehen. Bei Fragen bezüglich unseres Datenschutzes
        wenden Sie sich bitte an unseren Datenschutzbeauftragen.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        <strong>MEKO Metallkomponenten Ges.m.b.H.</strong>
        <br />
        Triester Straße 447a
        <br />
        A-8055 Graz
        <br />
        Österreich
        <br />
        Tel: <a href="tel:+43316296959">+43 (0) 316 296 959</a>
        <br />
        Fax: <a href="tel:+4331629695910">+43 (0) 316 296 959 10</a>
        <br />
        E-Mail: <a href="mailto:info@meko.at">info@meko.at</a>
      </p>

      <h2>2. Kontaktdaten der datenschutzverantwortlichen Person</h2>
      <p>
        Mein Datenschutzbeauftragter.de <br />
        Herr Philipp Herold <br />
        Hafenstraße 1 a <br />
        23568 Lübeck <br />
        Tel: <a href="tel:+4945116085213">(+49) 451 – 16085213</a> <br />
        E-Mail: <a href="mailto:datenschutz@hub24.de">datenschutz@hub24.de</a>
      </p>
      <h2>3. Allgemeines zur Datenverarbeitung</h2>
      <h3>3.1.Umfang der Verarbeitung personenbezogener Daten</h3>
      <p>
        Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur,
        soweit dies zur Bereitstellung einer funktionsfähigen Website sowie
        unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung
        personenbezogener Daten unserer Nutzer erfolgt grundsätzlich nur nach
        Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen
        eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen
        nicht möglich ist und die Verarbeitung der Daten durch gesetzliche
        Vorschriften gestattet ist. Eine Weitergabe der personenbezogenen Daten
        an Dritte erfolgt nur im Rahmen einer vertraglich abgesicherten
        Auftragsdatenverarbeitung mit unseren internen Firmen der Gleich Gruppe
        sowie den beauftragten IT- Dienstleitern. Verantwortlich für diese Daten
        bleibt grundsätzlich die GLEICH Aluminium GmbH.
      </p>
      <h3>3.2.Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h3>
      <p>
        Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine
        Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a
        EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage.
      </p>
      <p>
        Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung
        eines Vertrages, dessen Vertragspartei die betroffene Person ist,
        erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage.
        Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung
        vorvertraglicher Maßnahmen erforderlich sind.
      </p>
      <p>
        Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer
        rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen
        unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.
      </p>
      <p>
        Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder
        einer anderen natürlichen Person eine Verarbeitung personenbezogener
        Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als
        Rechtsgrundlage.
      </p>
      <p>
        Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres
        Unternehmens oder eines Dritten erforderlich und überwiegen die
        Interessen, Grundrechte und Grundfreiheiten des Betroffenen das
        erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als
        Rechtsgrundlage für die Verarbeitung.
      </p>
      <h3>3.3 Datenlöschung und Speicherdauer</h3>
      <p>
        Die personenbezogenen Daten der betroffenen Person werden gelöscht oder
        gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung
        kann darüber hinaus erfolgen, wenn dies durch den europäischen oder
        nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder
        sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen
        wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn
        eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft,
        es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der
        Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht.
      </p>
      <h2>4. Bereitstellung der Webseite</h2>
      <p>
        Dieser Datenschutzhinweis enthält Informationen zur Datenverarbeitung
        auf der Internetseite der MEKO Metallkomponenten Ges.m.b.H.:
        <br />
        <br />
        www.meko.at
        <br />
        <br />
        Sofern auf unseren digitalen Angeboten die Möglichkeit der optionalen
        Eingabe persönlicher Daten besteht, bitten wir Sie, für sich selbst zu
        prüfen, welche Daten Sie uns gegenüber preisgeben möchten. Die als
        solche gekennzeichneten Pflichtfelder benötigen wir zur Bearbeitung der
        jeweiligen Anfrage oder Ihres Auftrags. Darüber hinaus erhobene Daten
        sind freiwillig und werden zur Optimierung unseres Serviceangebots und
        gegebenenfalls zu Statistikzwecken verwendet.
      </p>
      <h3>4.1. Webhosting</h3>
      <p>
        Wir hosten die Inhalte unserer Website bei der Hetzner Online GmbH,
        Industriestr. 25, 91710 Gunzenhausen (nachfolgend Hetzner). Wenn Sie
        unsere Website besuchen, erfasst Hetzner verschiedene Logfiles inklusive
        Ihrer IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von
        Hetzner: https://www.hetzner.com/de/legal/privacy-policy/.
      </p>
      <p></p>

      <h2>3. Weitergabe von Daten</h2>
      <p>
        Eine Weitergabe Ihrer personenbezogenen Daten an Dritte zu anderen als
        den im Folgenden aufgeführten Zwecken findet nicht statt.
      </p>
      <p>
        Die Verwendung von Hetzner erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
        f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst
        zuverlässigen Darstellung unserer Website. Sofern eine entsprechende
        Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich
        auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG,
        soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf
        Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im
        Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
      </p>
      <p>
        <b>Auftragsverarbeitung</b>
      </p>
      <p>
        Wir haben mit Hetzner einen Vertrag über Auftragsverarbeitung (AVV) zur
        Nutzung der oben genannten Dienste geschlossen. Hierbei handelt es sich
        um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
        gewährleistet, dass dieser die personenbezogenen Daten unserer
        Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
        DSGVO verarbeitet
      </p>
      <h3>4.2. SSL-Verschlüsselung</h3>
      <p>
        Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden
        wir die auf dem aktuellen Stand der Technik entsprechenden
        Verschlüsselungsverfahren (z. B. SSL) über HTTPS.
      </p>
      <p>
        Eine Weiterleitung an dritte Unternehmen oder Organisationen ist ohne
        Ihre Genehmigung nicht möglich. Eine eventuelle Übermittlung der Daten
        erfolgt ausschließlich im Rahmen einer Auftragsdatenverarbeitung, d.h.
        wenn die Verantwortung für die Verarbeitung bei MEKO Metallkomponenten
        Ges.m.b.H bleibt.
      </p>
      <h2>5. Datenerfassung auf unseren Webseiten</h2>
      <h3>5.1. Beschreibung und Umfang der Datenverarbeitung</h3>
      <p>
        Die Internetseite erfasst mit jedem Aufruf durch eine betroffene Person
        oder ein automatisiertes System eine Reihe von allgemeinen Daten und
        Informationen. Diese allgemeinen Daten und Informationen werden in den
        Logfiles des Servers gespeichert. Erfasst werden können:
      </p>
      <ul>
        <li>die verwendeten Browsertypen und Versionen,</li>
        <li>das vom zugreifenden System verwendete Betriebssystem,</li>
        <li>
          die Internetseite, von welcher ein zugreifendes System auf unsere
          Internetseite gelangt (sogenannte Referrer),
        </li>
        <li>
          die Unterwebseiten, welche über ein zugreifendes System auf unserer
          Internetseite angesteuert werden,
        </li>
        <li>das Datum und die Uhrzeit eines Zugriffs auf die Internetseite,</li>
        <li>eine Internet-Protokoll-Adresse (IP-Adresse),</li>
        <li>der Internet-Service-Provider des zugreifenden Systems</li>
      </ul>
      <p>
        und sonstige ähnliche Daten und Informationen, die der Gefahrenabwehr im
        Falle von Angriffen auf unsere informationstechnologischen Systeme
        dienen.
      </p>
      <p>
        Bei der Nutzung dieser allgemeinen Daten und Informationen zieht die
        Meko keine Rückschlüsse auf die betroffene Person. Diese Informationen
        werden vielmehr benötigt, um
      </p>
      <ul>
        <li>die Inhalte unserer Internetseite korrekt auszuliefern,</li>
        <li>
          die Inhalte unserer Internetseite sowie die Werbung für diese zu
          optimieren,
        </li>
        <li>
          die dauerhafte Funktionsfähigkeit unserer informationstechnologischen
          Systeme und der Technik unserer Internetseite zu gewährleisten
        </li>
      </ul>
      <p>
        sowie um Strafverfolgungsbehörden im Falle eines Cyberangriffes die zur
        Strafverfolgung notwendigen Informationen bereitzustellen.
      </p>
      <p>
        Diese anonym erhobenen Daten und Informationen werden durch die Meko
        daher einerseits statistisch und ferner mit dem Ziel ausgewertet, den
        Datenschutz und die Datensicherheit in unserem Unternehmen zu erhöhen,
        um letztlich ein optimales Schutzniveau für die von uns verarbeiteten
        personenbezogenen Daten sicherzustellen. Die anonymen Daten der
        Server-Logfiles werden getrennt von allen durch eine betroffene Person
        angegebenen personenbezogenen Daten gespeichert.
      </p>
      <p>
        Wir erfassen und bearbeiten solche persönlichen Informationen stets in
        Übereinstimmung mit den gesetzlichen Vorgaben und den im Folgenden
        wiedergegebenen Erläuterungen.
      </p>
      <h3>
        5.2. Wie verarbeiten und verwenden wir Ihre persönlichen Informationen ?
      </h3>
      <p>
        Die von Ihnen angegebenen persönlichen Informationen werden von der MEKO
        in einer Kontaktdatenbank gespeichert. Die MEKO nutzt diese
        Informationen grundsätzlich nur innerhalb des eigenen Unternehmens und
        nur zur Abwicklung des bei der Erhebung genannten Zweckes, also z.B. zur
        Abwicklung von Verträgen bzw. Lieferung von Waren. Eine Übermittlung der
        Daten erfolgt ansonsten vor allem zur Durchführung des von Ihnen mit uns
        geschlossenen Vertrages an Dienstleistungsunternehmen, so geben wir Ihre
        Daten an das mit der Lieferung beauftragte Versandunternehmen oder zur
        Abwicklung von Zahlungen (Kreditkarte, Lastschriftverfahren) an das
        beauftragte Bankinstitut weiter, wobei Sie durch die Angabe der
        entsprechenden Informationen ihr Einverständnis erklären.
      </p>
      <h3>5.3. Cookies</h3>
      <p>
        Die Webseite der MEKO verwendet Cookies. Cookies sind Textbausteine, die
        in der Cookie-Datenbank Ihres Webbrowsers hinterlegt und auf Ihrer
        Festplatte gespeichert werden und den schnelleren Zugriff auf die
        Webseiten der MEKO ermöglichen sollen. Cookies verbessern Ihr Erlebnis
        der Webseite. Wir speichern keine persönlichen Daten in diesen Cookies,
        sondern lediglich den Textbaustein, mit dessen Hilfe wir Sie
        identifizieren können. Falls Sie die Verwendung von Cookies nicht
        wünschen, können Sie diese über Ihre Browser-Einstellungen deaktivieren.
        Sollten Sie weitere Informationen zum Thema Cookies benötigen, wenden
        Sie sich bitte an den Entwickler Ihres Browsers.
      </p>
      <h3>Einwilligung mit Consent Technologie:</h3>
      <p>
        Wenn Sie unsere Website betreten, wird ein Cookie in Ihrem Browser
        gespeichert, in dem die von Ihnen erteilten Einwilligungen oder der
        Widerruf dieser Einwilligungen gespeichert werden bis Sie uns zur
        Löschung auffordern bzw. das Cookie selbst löschen oder der Zweck für
        die Datenspeicherung entfällt.
      </p>
      <ConsentStatusViewer />
      <p>
        Sie können Ihre Einwilligungen jederzeit ändern oder widerrufen, indem
        Sie auf den Button „Cookie-Einstellungen“ klicken, der auf unserer
        Website verfügbar ist. Alternativ können Sie Ihre Einwilligungen auch
        über die Einstellungen Ihres Browsers verwalten. Bitte beachten Sie,
        dass die Deaktivierung von Cookies die Funktionalität unserer Website
        beeinträchtigen kann.
      </p>
      <h3>5.4 Kontaktformular</h3>
      <p>
        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
        Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen
        Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
        Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne
        Ihre Einwilligung weiter.
      </p>
      <p>
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
        zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
        erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
        unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
        gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
        Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde;
        die Einwilligung ist jederzeit widerrufbar.
      </p>
      <p>
        Bis Sie uns zur Löschung dieser Daten auffordern oder Ihre Einwilligung
        zur Speicherung derselben widerrufen verbleiben diese Daten bei uns. Sie
        werden zur Bearbeitung der Anfrage sowie für mögliche Anschlussfragen
        gespeichert.
      </p>
      <h3>5.5 Anfrage per E-Mail, Telefon oder Telefax</h3>
      <p>
        Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre
        Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
        (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
        gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
        Einwilligung weiter.
      </p>
      <p>
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
        zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
        erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
        unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
        gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
        Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde;
        die Einwilligung ist jederzeit widerrufbar.
      </p>
      <p>
        Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben
        bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
        Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
        (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
        gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen
        – bleiben unberührt.
      </p>
      <h2>6. Webanalyse</h2>
      <h3>Google Analytics</h3>
      <p>
        Wir setzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse
        an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres
        Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Google
        Analytics, einen Webanalysedienst der Google LLC („Google“) ein. Google
        verwendet Cookies. Die durch das Cookie erzeugten Informationen über
        Benutzung des Onlineangebotes durch die Nutzer werden in der Regel an
        einen Server von Google in den USA übertragen und dort gespeichert.
        Google wird diese Informationen in unserem Auftrag benutzen, um die
        Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um Reports
        über die Aktivitäten innerhalb dieses Onlineangebotes zusammenzustellen
        und um weitere, mit der Nutzung dieses Onlineangebotes und der
        Internetnutzung verbundene Dienstleistungen, uns gegenüber zu erbringen.
        Dabei können aus den verarbeiteten Daten pseudonyme Nutzungsprofile der
        Nutzer erstellt werden. Wir setzen Google Analytics nur mit aktivierter
        IP-Anonymisierung ein. Das bedeutet, die IP-Adresse der Nutzer wird von
        Google innerhalb von Mitgliedstaaten der Europäischen Union oder in
        anderen Vertragsstaaten des Abkommens über den Europäischen
        Wirtschaftsraum gekürzt. Die von dem Browser des Nutzers übermittelte
        IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Die
        Installation von Cookies können Sie verhindern, indem Sie vorhandene
        Cookies löschen und in unserem Cookie Consent Tool die Speicherung von
        Cookies für Webanalyse ablehnen. Weitere Informationen zur Datennutzung
        durch Google, Einstellungs- und Widerspruchsmöglichkeiten, erfahren Sie
        in der Datenschutzerklärung von Google (
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/technologies/ads
        </a>
        ) sowie in den Einstellungen für die Darstellung von Werbeeinblendungen
        durch Google (
        <a
          href="https://adssettings.google.com/authenticated"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://adssettings.google.com/authenticated
        </a>
        ).
      </p>
      <h3>Google Tag Manager</h3>
      <p>
        Diese Webseite verwendet den Google Tag Manager. Durch diesen Dienst
        können Website-Tags über eine Oberfläche verwaltet werden. Der Google
        Tag Manager implementiert lediglich Tags. Das bedeutet: es werden keine
        Cookies eingesetzt und keine personenbezogenen Daten erfasst. Der Google
        Tag Manager löst andere Tags aus, die wiederum ggf. Daten erfassen.
        Jedoch greift der Google Tag Manager nicht auf diese Daten zu. Wurde auf
        Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen, so bleibt sie
        für alle Tracking-Tags bestehen, insofern diese mit dem Google Tag
        Manager implementiert werden.
      </p>
      <h2>7. Onlinemarketing</h2>
      <h3>Google Ads</h3>
      <p>
        Wir nutzen das Onlinemarketingverfahren Google Ads , einen Dienst der
        Google Ireland Limited, Google Building Gordon House, Barrow St, Dublin
        4, Irland (nachfolgend bezeichnet als „Google“), um Anzeigen in den
        Suchergebnissenim des Google-Werbe-Netzwerk zu platzieren, damit sie
        Nutzern angezeigt werden, die ein mutmaßliches Interesse an den Anzeigen
        haben. Dies erlaubt uns Anzeigen für und innerhalb unseres
        Onlineangebotes gezielter anzuzeigen, um Nutzern nur Anzeigen zu
        präsentieren, die potentiell deren Interessen entsprechen. Wir erhalten
        ein individuelles „Conversion-Cookie“, das nach 30 Tagen seine
        Gültigkeit verliert. Die mit Hilfe des Cookies eingeholten Informationen
        dienen Google dazu, Conversion-Statistiken für uns zu erstellen. Wir
        erfahren jedoch nur die anonyme Gesamtanzahl der Nutzer, die auf unsere
        Anzeige geklickt haben und zu einer mit einem Conversion-Tracking-Tag
        versehenen Seite weitergeleitet wurden. Wir erhalten keine
        Informationen, mit denen sich Nutzer persönlich identifizieren lassen.
        Wir verwenden Google Ads zu Marketing- und Optimierungszwecken,
        insbesondere um für Sie relevante und interessante Anzeigen zu schalten,
        die Berichte zur Kampagnenleistung zu verbessern und eine faire
        Berechnung von Werbekosten zu erreichen. Hierin liegt auch unser
        berechtigtes Interesse an der Verarbeitung der vorstehenden Daten durch
        den Drittanbieter. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO.
      </p>
      <h2>8. YouTube-Videos mit erweitertem Datenschutz</h2>
      <p>
        Wir haben YouTube-Videos in unsere Internetseite eingebunden. Wir nutzen
        die YouTube Funktion No-Cookies, d.h. wir haben Erweiterten Datenschutz
        aktiviert, Videos werden nicht über youtube.com, sondern über
        youtube-nocookie.com aufgerufen. Diesen stellt YouTube selbst bereit und
        sichert damit zu, dass YouTube zunächst keine Cookies auf Ihrem Gerät
        speichert. Beim Aufruf der betreffenden Seiten werden allerdings die
        IP-Adresse sowie die in Ziffer 4 genannten weiteren Daten übertragen und
        so insbesondere mitgeteilt, welche unserer Internetseiten Sie besucht
        haben. Diese Information lässt sich jedoch nicht Ihnen zuordnen, wenn
        Sie bei dem Seitenaufruf bei YouTube oder einem anderen Google-Dienst
        dauerhaft angemeldet sind.
      </p>
      <p>
        Sobald Sie die Wiedergabe eines eingebundenen Videos durch Anklicken
        starten, speichert YouTube durch den erweiterten Datenschutzmodus auf
        Ihrem Gerät nur Cookies, die keine persönlich identifizierbaren Daten
        enthalten, es sei denn Sie sind aktuell bei einem Google-Dienst
        angemeldet. Diese Cookies lassen sich durch entsprechende
        Browsereinstellungen und -erweiterungen verhindern.
      </p>
      <p>
        Google/YouTube: Google Ireland Limited, Gordon House, Barrow Street,
        Dublin 4, Irland – Datenschutzerklärung:
        https://policies.google.com/privacy, Opt-Out:
        https://adssettings.google.com/authenticated.
      </p>
      <h2>9. Recht der Betroffenen</h2>
      <p>
        Sie haben das Recht:
        <br />
        <br />
        <ul>
          <li>
            gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten
            personenbezogenen Daten zu verlangen;
          </li>
          <li>
            gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
            Vervollständigung Ihrer bei uns gespeicherten personenbezogenen
            Daten zu verlangen;
          </li>
          <li>
            gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten
            personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung
            zur Ausübung des Rechts auf freie Meinungsäußerung und Information,
            zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des
            öffentlichen Interesses oder zur Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen erforderlich ist;
          </li>
          <li>
            gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen, soweit:
          </li>
          <li>die Richtigkeit der Daten von Ihnen bestritten wird,</li>
          <li>
            die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen
            und wir die Daten nicht mehr benötigen, Sie jedoch diese zur
            Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen
            benötigen oder
          </li>
          <li>
            Sie gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung eingelegt
            haben;
          </li>
          <li>
            gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns
            bereitgestellt haben, in einem strukturierten, gängigen und
            maschinenlesebaren Format zu erhalten oder die Übermittlung an einen
            anderen Verantwortlichen zu verlangen;
          </li>
          <li>
            gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung
            jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge, dass wir
            die Verarbeitung, soweit sie auf dieser Einwilligung beruhte, für
            die Zukunft nicht mehr fortführen dürfen;
          </li>
          <li>
            gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren.
            In der Regel können Sie sich hierfür an die Aufsichtsbehörde Ihres
            üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres Sitzes
            wenden;
          </li>
          <li>
            gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer
            personenbezogenen Daten einzulegen, sofern Ihre personenbezogenen
            Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1
            S. 1 lit. f DSGVO verarbeitet werden und sich der Widerspruch gegen
            Direktwerbung richtet oder Gründe für den Widerspruch vorliegen, die
            sich aus Ihrer besonderen Situation ergeben oder. Möchten Sie von
            Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine
            E-Mail an datenschutz@gleich.de.
          </li>
          <li>
            Wir bedienen uns im Übrigen geeigneter technischer und
            organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen
            zufällige oder vorsätzliche Manipulationen, teilweisen oder
            vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff
            Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend
            der technologischen Entwicklung fortlaufend verbessert.
          </li>
        </ul>
      </p>
      <h2>10. Stand der Datenschutzerklärung</h2>
      <p>
        Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Februar
        2026.
      </p>
      <p>
        Durch die Weiterentwicklung unserer Website und Angebote darüber oder
        aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es
        notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils
        aktuelle Datenschutzerklärung kann jederzeit auf dieser Seite von Ihnen
        abgerufen und ausgedruckt werden.
      </p>
    </div>
  );
};

export default DatenschutzDe;
